import { useSearchParams } from '@remix-run/react';
import { styled } from 'styled-components';
import { handleLoader } from '@app/lib/RemixHelpers.server';
import AuthMain, { AuthView } from '@components/auth/AuthMain';
import ProjectBookDark from '@icons/Project-Book-Dark.svg?react';
import { getLoggedInUserInfo } from '@server/lib/Auth.server';
import { getBestRouteToLandUser } from '@server/lib/User.server';
import { Routes } from '@shared/constants/RouteConstants';

export const loader = handleLoader(async ({ request, redirect }) => {
  const { user } = await getLoggedInUserInfo({ request });
  if (user) {
    const redirectUrl = await getBestRouteToLandUser(user);
    // TOOD: redirectto a workspace generation page
    if (redirectUrl === Routes.SignUp) {
      throw new Error('Redirect URL is SignUp, which is not allowed.');
    }
    return redirect(redirectUrl);
  }
  return {};
});

// Styled Components
const OnboardingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100vh;
`;

const AuthBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const AuthBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledProjectBookDark = styled(ProjectBookDark)`
  width: 100px;
  height: auto;
`;

export default function DesktopAppMainLanding() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view');
  const invitationToken = searchParams.get('invitationToken');
  const defaultAuthView = view === 'login' ? AuthView.LOGIN : undefined;

  return (
    <OnboardingContainer>
      <AuthBlockWrapper>
        <StyledProjectBookDark />
        <AuthBlock>
          <AuthMain defaultAuthView={defaultAuthView} invitationToken={invitationToken} />
        </AuthBlock>
      </AuthBlockWrapper>
    </OnboardingContainer>
  );
}
